var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-title"},[_c('p',[_vm._v(_vm._s(_vm.item.title))]),_c('button',[_vm._v("立即报名")])])
}
var staticRenderFns = []

export { render, staticRenderFns }